import { getGameInfoForVariant } from './game-registry';
import { BettingStructure } from './game-types';
import { PokerVariant } from './poker-variant';

const normalizeVariant = (variant: string | PokerVariant): PokerVariant => variant as PokerVariant;

const getVariantStructure = (variant: string | PokerVariant): BettingStructure => {
  const info = getGameInfoForVariant(normalizeVariant(variant));
  return info.bettingStructure;
};

const isVariantBlindBased = (variant: string | PokerVariant): boolean => {
  const structure = getVariantStructure(variant);
  return structure === BettingStructure.NO_LIMIT || structure === BettingStructure.POT_LIMIT;
};

const isVariantFixedLimit = (variant: string | PokerVariant): boolean => {
  return getVariantStructure(variant) === BettingStructure.FIXED_LIMIT;
};

const mixedGameHasFixedLimitVariant = (variants: Array<string | PokerVariant>): boolean => {
  return variants.some(isVariantFixedLimit);
};

export const isMixedGameBlindBasedOnly = (variants: Array<string | PokerVariant>): boolean => {
  if (!variants.length) {
    return false;
  }

  if (variants.length === 1) {
    return isVariantBlindBased(variants[0]);
  }

  return variants.every(isVariantBlindBased);
};

export const resolveMixedGameBettingStructure = (variants: Array<string | PokerVariant>): BettingStructure => {
  if (!variants.length) {
    return BettingStructure.NO_LIMIT;
  }

  const firstStructure = getVariantStructure(variants[0]);

  if (variants.length === 1) {
    return firstStructure;
  }

  if (mixedGameHasFixedLimitVariant(variants)) {
    return BettingStructure.MIXED_LIMIT;
  }

  return firstStructure;
};
